import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from "react";
import { Link } from "@zapier/design-system";
import { ButtonLink } from "@zapier/upsells/esm/components";
export const viewTypes = {
    DEFAULT: "DEFAULT",
    DEFAULT_TRIGGERED_BY_ZAP: "DEFAULT_TRIGGERED_BY_ZAP",
    TRIAL_EXTENSION: "TRIAL_EXTENSION",
    TRIAL_EXTENSION_TRIGGERED_BY_ZAP: "TRIAL_EXTENSION_TRIGGERED_BY_ZAP",
};
const views = {
    ["DEFAULT"]: ({ onUpgradeClick, wasTriggeredByZapToggle }) => wasTriggeredByZapToggle
        ? {
            bodyText: (_jsxs(Fragment, { children: ["To turn on your Zap, you'll need access to", " ", _jsx(Link, { href: "/help/create/customize/add-branching-logic-to-zaps-with-paths", target: "_blank", children: "paths" }), ". Edit your Zap or upgrade now to turn on your Zap."] })),
            type: viewTypes.DEFAULT_TRIGGERED_BY_ZAP,
        }
        : {
            bodyText: (_jsxs(Fragment, { children: ["With", " ", _jsx(Link, { href: "/help/create/customize/add-branching-logic-to-zaps-with-paths", target: "_blank", children: "paths" }), ", your Zap can perform different actions based on different conditions. Upgrade to our", " ", _jsx(ButtonLink, { onClick: onUpgradeClick, children: "Professional plan" }), " ", "to use paths."] })),
            type: viewTypes.DEFAULT,
        },
    ["TRIAL_EXTENSION"]: ({ onUpgradeClick, wasTriggeredByZapToggle, }) => wasTriggeredByZapToggle
        ? {
            bodyText: (_jsxs(Fragment, { children: ["To turn on your Zap, you'll need access to", " ", _jsx(Link, { href: "/help/create/customize/add-branching-logic-to-zaps-with-paths", target: "_blank", children: "paths" }), ". Upgrade now or start a free 7-day trial of the", " ", _jsx(ButtonLink, { onClick: onUpgradeClick, children: "Professional plan" }), " ", "to use premium features like paths."] })),
            type: viewTypes.TRIAL_EXTENSION_TRIGGERED_BY_ZAP,
        }
        : {
            bodyText: (_jsxs(Fragment, { children: ["With", " ", _jsx(Link, { href: "/help/create/customize/add-branching-logic-to-zaps-with-paths", target: "_blank", children: "paths" }), ", your Zap can perform different actions based on different conditions. Upgrade now or start a free 7-day trial of our", " ", _jsx(ButtonLink, { onClick: onUpgradeClick, children: "Professional plan" }), " ", "to use paths."] })),
            type: viewTypes.TRIAL_EXTENSION,
        },
};
export const getActiveView = ({ canExtendTrial, onUpgradeClick, wasTriggeredByZapToggle, }) => canExtendTrial
    ? views.TRIAL_EXTENSION({ onUpgradeClick, wasTriggeredByZapToggle })
    : views.DEFAULT({ onUpgradeClick, wasTriggeredByZapToggle });

// @zapier/upsells@8.0.1 (466b4077f)
